import { render, staticRenderFns } from "./table-footer.vue?vue&type=template&id=5445683c&"
import script from "./table-footer.ts?vue&type=script&lang=ts&"
export * from "./table-footer.ts?vue&type=script&lang=ts&"
import style0 from "./table-footer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports